/*
 * Password reset actions
 */

export const PASSWORD_RESET_REQUEST = 'PASSWORD_RESET_REQUEST';
export const PASSWORD_RESET_REQUEST_SUCCESS = 'PASSWORD_RESET_REQUEST_SUCCESS';
export const PASSWORD_RESET_REQUEST_ERROR = 'PASSWORD_RESET_REQUEST_ERROR';

export const passwordResetRequest = (email) => ({ type: PASSWORD_RESET_REQUEST, payload: email });
export const passwordResetRequestSuccess = (data) => ({
  type: PASSWORD_RESET_REQUEST_SUCCESS,
  payload: data,
});
export const passwordResetRequestError = (error) => ({
  type: PASSWORD_RESET_REQUEST_ERROR,
  error: error,
});

export const GRANT_PASSWORD_RESET_PRIVILEGE = 'GRANT_PASSWORD_RESET_PRIVILEGE';
export const GRANT_PASSWORD_RESET_PRIVILEGE_SUCCESS = 'GRANT_PASSWORD_RESET_PRIVILEGE_SUCCESS';
export const GRANT_PASSWORD_RESET_PRIVILEGE_ERROR = 'GRANT_PASSWORD_RESET_PRIVILEGE_ERROR';

export const grantPasswordResetPrivilege = (credentials) => ({
  type: GRANT_PASSWORD_RESET_PRIVILEGE,
  payload: credentials,
});
export const grantPasswordResetPrivilegeSuccess = (data) => ({
  type: GRANT_PASSWORD_RESET_PRIVILEGE_SUCCESS,
  payload: data,
});
export const grantPasswordResetPrivilegeError = (error) => ({
  type: GRANT_PASSWORD_RESET_PRIVILEGE_ERROR,
  error: error,
});

export const PASSWORD_RESET = 'PASSWORD_RESET';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_ERROR = 'PASSWORD_RESET_ERROR';

export const passwordReset = (input) => ({ type: PASSWORD_RESET, payload: input });
export const passwordResetSuccess = (data) => ({ type: PASSWORD_RESET_SUCCESS, payload: data });
export const passwordResetError = (error) => ({ type: PASSWORD_RESET_ERROR, error: error });
